import React, { useEffect, useState } from 'react';
import { isIOS } from '@croquiscom/web2app';
import { Text } from '@croquiscom-pvt/zds';
import styled from '@emotion/styled';

import { isApp } from '@common/device-manager';

interface Props {
  title: string;
  content_list: string[];
}

export const PurchaseNotice = ({ title, content_list }: Props) => {
  const [indent, setIndent] = useState<number>(-7);

  useEffect(() => {
    if (!isApp() || isIOS()) {
      setIndent(-9);
    }
  }, []);

  return (
    <Container>
      <Text variant='Body_15_SemiBold' color='textPrimary' style={{ marginBottom: 12 }}>
        {title}
      </Text>
      <PurchaseNoticeContent indent={indent}>
        {content_list.map((content, index) => (
          <Text key={index} variant='Body_13_Regular' color='textSecondary'>
            {content}
          </Text>
        ))}
      </PurchaseNoticeContent>
    </Container>
  );
};

const Container = styled.div`
  padding: 24px 16px 0 16px;
  text-align: left;
`;

const PurchaseNoticeContent = styled.div<{ indent: number }>`
  p {
    padding-left: 7px;
    margin-top: 12px;
    line-height: 155%;
    ${({ indent }) => indent && `text-indent: ${indent}px`};
  }
`;
